<template>
  <div class="back-top" v-if="btnFlag">
    <div class="item kefu">
      <div class="service">
        <div class="s-l">
          <div class="tel">
            <icon iconClass="telphone"></icon>24小时全国服务热线
          </div>
          <div class="tel-num">400-632-8880</div>
        </div>
        <div class="jd-t">
          <div
            class="js-img"
            @click="goLink('https://mall.jd.com/index-11466759.html')"
          >
            <icon iconClass="jdIcon" class="jd"></icon>京东在线店铺
          </div>
          <div class="arrow"><icon iconClass="arrow"></icon></div>
        </div>
        <div class="d-flex s-r">
          <div>
            <div>官网公众号</div>
            <img
              src="@/assets/images/image-v2.0.0/amdox-QR.png"
              alt=""
              class="erweima"
            />
          </div>
          <div>
            <div>微信客服号</div>
            <img
              src="@/assets/images/image-v2.0.0/kfwx.png"
              alt=""
              class="erweima"
            />
          </div>
        </div>
      </div>

      <div
        class="_right service-icon"
        @mouseenter="
          customerServiceClass = 'customer_service-1';
          hover = false;
        "
        @mouseout="
          customerServiceClass = 'customer_service';
          hover = true;
        "
      >
        <Icon :iconClass="customerServiceClass"></Icon>
      </div>
    </div>
    <div class="item top">
      <div
        class="_right"
        @click="_backTop"
        @mouseenter="backTopClass = 'backtop2'"
        @mouseleave="backTopClass = 'backtop1'"
      >
        <Icon :iconClass="backTopClass"></Icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customerServiceClass: "customer_service",
      backTopClass: "backtop1",
      hover: true,
      scrollTop: 0,
      btnFlag: false,
    };
  },
  methods: {
    goLink(link) {
      window.open(link, "_blank");
    },
    goServe() {
      window.open("https://url.cn/D1LRxZe2?_type=wpa&qidian=true", "_blank");
    },
    _backTop() {
      this.backTop();
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let timer = setInterval(() => {
        let ispeed = Math.floor(-this.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          this.scrollTop + ispeed;
        if (this.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于300显示回顶部图标，小于300则隐藏
    scrollToTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
      if (this.scrollTop > 300) {
        this.btnFlag = true;
      } else {
        this.btnFlag = false;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
};
</script>

<style lang="scss" scoped>
.back-top {
  position: fixed;
  right: 2em;
  bottom: 20%;
  transform: translateY(50%);
  display: flex;
  flex-direction: column;
  z-index: 999;
  .item {
    position: relative;
    display: flex;
    &:hover {
      .service {
        display: block;
        transform: translateX(0%);
      }
    }
  }
  .top {
    ._right {
      &:hover {
        .svg-icon {
          color: #858585 !important;
        }
      }
    }
  }
  .service-icon:hover .service {
    opacity: 1;
  }
  .kefu {
    .service {
      display: block;
      background: #fff;
      position: absolute;
      right: 100%;
      top: -180%;
      // transform: translateY(-50%);
      transform: translateX(150%);
      transition: all 1s;
      // width: 300rem / $rem;
      padding: 30rem / $rem 0;
      .s-l {
        padding: 0 40rem / $rem;
        white-space: nowrap;
        .tel {
          font-size: 14rem / $rem;
          .svg-icon {
            font-size: 20rem / $rem;
            margin-right: 27rem / $rem;
          }
        }
        .tel-num {
          font-size: 14rem / $rem;
          color: #32b332;
          font-weight: 700;
          margin-left: 50rem / $rem;
        }
      }
      .jd-t {
        padding: 0 0 0 40rem / $rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 50rem / $rem;
        margin: 30rem / $rem 0;
        white-space: nowrap;
        .js-img {
          display: flex;
          align-items: center;
        }
        .svg-icon {
          font-size: 32rem / $rem;
          margin-right: 27rem / $rem;
        }
        .arrow {
          display: flex;
          align-items: center;
          .svg-icon {
            font-size: 14rem / $rem;
            margin-right: 27rem / $rem;
          }
        }
        &:hover {
          background: #eeeeee;
        }
      }
      .s-r {
        padding: 0 40rem / $rem;
        font-size: 12rem / $rem;
        text-align: center;
        display: flex;
        justify-content: center;
        .erweima {
          width: 86rem / $rem;
          height: auto;
        }
      }
    }
  }
  ._right {
    width: 50rem / $rem;
    height: 50rem / $rem;
    border-radius: 14rem / $rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.5em;
    cursor: pointer;
    .svg-icon {
      color: #fff;
      font-size: 42rem / $rem;
    }
    span {
      word-break: break-all;
      color: #fff;
      font-size: 16rem / $rem;
    }
  }
}
</style>